module.exports = __webpack_public_path__ + "media/TNTO-video.30de1e8d.webm";